import { Grid, GridProps, styled } from "@mui/material";
import React from "react";

export interface MxEmptyCardProps extends GridProps {
  children?: React.ReactNode;
  size?: "page" | "section" | "card";
}
const MxEmptyCard = (props: MxEmptyCardProps) => {
  const { size, className, ...rest } = props;
  return (
    <ContentWrap container size={size} className={className}>
      <Content {...rest} />
    </ContentWrap>
  );
};

export default MxEmptyCard;

const Content = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  height: "min-content",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: 20,
  borderRadius: 14,
  minHeight: 100,
  padding: 30
}));

const ContentWrap = styled(Grid)<{ size?: "page" | "section" | "card" }>(
  ({ theme, size = "card" }) => ({
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    height: `
           ${size === "page" ? "calc(100vh - 120px)" : ""}
           ${size === "section" ? "100%" : ""}
           ${size === "card" ? "auto" : ""}
         `
  })
);
